export const PATH_BUY = '/buy';
export const PATH_BUY_SIGNUP = '/buy/signup';
export const PATH_BUY_LOGIN = '/buy/login';
export const PATH_BUY_ADD = '/buy/add/:productId([0-9]+)';
export const PATH_BUY_THANK_YOU = '/buy/thank-you/:token';
export const PATH_DOWNLOAD_THE_APP = '/downloadtheapp';
